import { useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import { FetchSuccess } from '../../../../types';
import { AuthContext } from '../../../../context/All/AuthContext';
import { MessagesContext } from '../../../../context/All/Messages';
import { ICoursesParams } from '../../interfaces';

export interface IUseEditCourse {
  data: FetchSuccess | null;
  editCourse: (params: ICoursesParams, id: number) => void;
}

export const useEditCourse = (): IUseEditCourse => {
  const { user } = AuthContext();
  const { addErrors } = MessagesContext();
  const [data, setData] = useState<FetchSuccess | null>(null);

  const editCourse = (params: ICoursesParams, id: number) => {
    axios.patch(`${process.env.REACT_APP_API_URL}/courses/${id}`, params, {
      headers: {
        Authorization: `Bearer ${user?.accessToken}`,
      },
    })
      .then((response: AxiosResponse<FetchSuccess | null>) => {
        setData(response.data);
      })
      .catch((error) => {
        addErrors(error.response.data.message);
      });
  };

  return { data, editCourse };
};
